import axios from "axios";

const httpClient = axios.create();

// adds access tokens in all api requests
// this interceptor is only added when the auth0 instance is ready and exports the getAccessTokenSilently method
export const addAccessTokenInterceptor = (getAccessTokenSilently) => {
  httpClient.interceptors.request.use(async (config) => {
    const newConfig = config;
    const { audience } = window.globalConfig?.auth0 || {};
    const token = await getAccessTokenSilently({
      authorizationParams: {
        audience,
      },
    });
    newConfig.headers.Authorization = `Bearer ${token}`;
    return newConfig;
  });
};

export default httpClient;

/**
 * Standard fetcher for SWR using the pre-configured axios client.
 *
 * @param {Object} config - Axios config object.
 * @returns {Promise<any>}
 */
export const swrFetcher = async (config) => {
  if (!config || !config.url) {
    throw new Error("SWR fetcher requires an axios config object with a 'url' property.");
  }

  const finalConfig = {
    ...config,
    method: "get",
  };

  const response = await httpClient.request(finalConfig);
  return response.data;
};
